import { FormEvent, useRef, useState } from 'react'
import { useQueryClient } from 'react-query'
import toast from 'react-hot-toast'
import { useUploadDocument } from '../../api/attachment'
import Button from '@mui/material/Button'

interface Props {
  attachmentId: string
}

export default function UplaodButton({ attachmentId }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [selectedFile, setSelectedFile] = useState<File>()
  const [isFilePicked, setIsFilePicked] = useState<boolean>(false)
  const upload = useUploadDocument(attachmentId)
  const queryClient = useQueryClient()

  const changeHandler = (event: FormEvent<HTMLInputElement>) => {
    const files = (event.target as HTMLInputElement).files
    if (!files) return
    setSelectedFile(files[0])
    setIsFilePicked(true)
  }

  const sumbit = async () => {
    if (!selectedFile) return
    const formData = new FormData()
    formData.append('file', selectedFile)
    formData.append('name', selectedFile.name)
    try {
      await upload.mutateAsync(formData)
      queryClient.invalidateQueries()
      handleRemoveFile()
      toast.success('با موفقیت آپلود شد.')
    } catch {
      toast.error('عملیات با خطا روبه‌رو شد.')
      handleRemoveFile()
    }
  }
  const openFileBrowser = () => {
    inputRef.current?.click()
  }

  const handleClick = () => {
    if (isFilePicked) sumbit()
    else openFileBrowser()
  }
  const handleRemoveFile = () => {
    setIsFilePicked(false)
    setSelectedFile(undefined)
  }

  return (
    <>
      <Button onClick={handleClick} fullWidth variant="contained">
        {!isFilePicked ? 'آپلود فایل' : upload.isLoading ? 'درحال ارسال' : 'ارسال فایل'}
      </Button>
      <input
        className="hidden"
        type="file"
        name="file"
        onChange={changeHandler}
        ref={inputRef}
      />
      <div className="flex flex-row justify-between h-4 px-3 mt-2 gap-2">
        <div className="text-xs text-ellipsis overflow-hidden whitespace-nowrap">
          {selectedFile?.name}
        </div>
        <div className="shrink-0">
          {isFilePicked && (
            <img
              src="/icons/close.svg"
              alt="close"
              className="cursor-pointer h-4"
              onClick={handleRemoveFile}
            />
          )}
        </div>
      </div>
    </>
  )
}
